import { useEffect, useState } from 'react'
import { RaytebRequests } from '../../../_services'
import useFetch from '../../../_services/fetch'
import {
  LoadingFit,
  SamadCard,
  SamadDeliveredCard,
} from '../../../share/Components'
import {
  Button,
  DatePicker,
  RaytebForm,
  TextBox,
} from '../../../share/Elements'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
type Pagination = {
  size: number
  index: number
}

const ListSamadPeresentation = ({ centerId, token }) => {
  const [list, setList] = useState<Array<ListSamadDeliveredViewModel>>([])
  const listSamadDelivered = useFetch<
    Array<ListSamadDeliveredViewModel>,
    ListSamadInputModel
  >({
    request: RaytebRequests.IHIO_GetListSamadDelivered_POST({
      headers: { centerId: centerId },
      token: token!,
    }),
    onSuccess(data) {
      setList([...list, ...data])
    },
  })
  const [pagination, setPagination] = useState<Pagination>({
    index: 1,
    size: 20,
  })

  useEffect(() => {
    listSamadDelivered.reFetch({
      fromDate: new Date(),
      toDate: new Date(),
      pageNumber: pagination.index,
      pageSize: pagination.size,
    })
  }, [])
  return (
    <div className='py-2'>
      <LoadingFit isLoading={listSamadDelivered.isLoading} fixed={true} />
      <RaytebForm
        checkIsRequired={true}
        className='relative md:max-w-md md:mx-auto px-4'
        onSubmit={(e) => {
          setList([])
          listSamadDelivered.reFetch({
            fromDate: new Date(
              e.target['fromDate'].getAttribute('rayteb-value')
            ),
            toDate: new Date(e.target['toDate'].getAttribute('rayteb-value')),
            pageNumber: 1,
            pageSize: pagination.size,
            patientCode: e.target['patientCode'].value,
          })
          setPagination({ index: 1, size: 20 })
        }}
      >
        <div className='px-4 mt-5 grid grid-cols-10 gap-3 '>
          <div className='col-span-5'>
            <DatePicker
              onChange={(e) => {
                document.getElementById('submitFormDelivered')?.click()
              }}
              innerText='از تاریخ'
              isRequired={true}
              className='h-7 w-full'
              name='fromDate'
              value={new Date().toShamsi()}
              raytebValue={new Date()}
            />
          </div>
          <div className='col-span-5'>
            <DatePicker
              onChange={(e) => {
                document.getElementById('submitFormDelivered')?.click()
              }}
              innerText='تا تاریخ'
              isRequired={true}
              className='h-7 w-full'
              name='toDate'
              value={new Date().toShamsi()}
              raytebValue={new Date()}
            />
          </div>
          <div className='col-span-10'>
            <TextBox
              onChange={(e) => {
                document.getElementById('submitForm')?.click()
              }}
              Type={TextBoxTypeEnum.Text}
              innerText='کد ملی بیمار یا کد اتباع'
              isRequired={false}
              Regular='^([0-9]|[a-z]){10,}$'
              RxgMessage='کد ملی یا کد اتباع باید بزرگتر از ده رقم باشد'
              className='h-7 w-full'
              name='patientCode'
            />
          </div>
        </div>
        <div className='px-4 mt-5 grid grid-cols-10 gap-3 md:gap-4 items-center justify-center content-center'></div>
        <input
          id='submitFormDelivered'
          type='submit'
          value={''}
          className='hidden'
        />
      </RaytebForm>
      <div className='sticky top-12 float-left pl-3 z-30'>
        <span className='p-1 rounded-b-lg bg-secondary text-xs text-white '>{`تعداد لیست : ${list.length}`}</span>
      </div>
      <p className='text-xs font-bold text-primary float-right pr-3'>
        <span className='mx-1 text-dangerDark text-sm'>*</span>
        لیست ویزیت های تحویل داده شده در بیمه سلامت
      </p>
      <div className=' grid grid-cols-1 gap-2 py-3 w-full'>
        {list.map((n, i) => (
          <SamadDeliveredCard
            key={i}
            model={n}
            centerId={centerId}
            token={token}
          />
        ))}
      </div>
      {listSamadDelivered.result &&
      listSamadDelivered.result?.length === pagination.size ? (
        <Button
          className='text-xs text-white rounded-b-full m-auto w-48 h-8'
          onClick={() => {
            listSamadDelivered.reFetch({
              fromDate: listSamadDelivered.payLoad?.fromDate!,
              toDate: listSamadDelivered.payLoad?.toDate!,
              pageNumber: pagination.index + 1,
              pageSize: pagination.size,
              patientCode: listSamadDelivered.payLoad?.patientCode,
            })
            setPagination({ ...pagination, index: pagination.index + 1 })
          }}
        >
          بیشتر
        </Button>
      ) : (
        ''
      )}
    </div>
  )
}

export default ListSamadPeresentation
